import React from "react";

// reactstrap components
import {
  Button,
  Row,
  Col,
  Carousel,
  CarouselItem,
  CarouselIndicators
} from "reactstrap";

// core components
const items = [
  {
    videoSrc: require("assets/video/p1.mp4"),
    content: (
      <Row>
        <Col md="5">
          <div className="iframe-container">

          </div>
        </Col>
        <Col className="ml-auto mr-auto text-right" md="6">
          <h1 className="title"></h1>
          <h4 className="description">
          
          </h4>
        </Col>
      </Row>
    ),
    altText: "",
    caption: ""
  },
  {
    videoSrc: require("assets/video/p2.mp4"),
    content: (
      <Row>
        <Col className="text-left" md="6">
          <h1 className="title">
            
          </h1>
          <h4 className="description">
          
          </h4>
          <br></br>
          <div className="buttons">
            <Button
              className="btn-neutral mr-1"
              color="info"
              href="#pablo"
              onClick={e => e.preventDefault()}
              size="lg"
            >
              <i className="now-ui-icons files_single-copy-04"></i> 
            </Button>
            <Button
              color="info"
              href="#pablo"
              onClick={e => e.preventDefault()}
              size="lg"
            >
              <i className="now-ui-icons arrows-1_share-66"></i> 
            </Button>
          </div>
        </Col>
      </Row>
    ),
    altText: "",
    caption: ""
  },
  {
    videoSrc: require("assets/video/p3.mp4"),
    content: (
      <Row>
        <Col className="text-left" md="6">
          <h1 className="title">
            
          </h1>
          <h4 className="description">
          
          </h4>
          <br></br>
          <div className="buttons">
            <Button
              className="btn-neutral mr-1"
              color="info"
              href="#pablo"
              onClick={e => e.preventDefault()}
              size="lg"
            >
              <i className="now-ui-icons files_single-copy-04"></i> 
            </Button>
            <Button
              color="info"
              href="#pablo"
              onClick={e => e.preventDefault()}
              size="lg"
            >
              <i className="now-ui-icons arrows-1_share-66"></i> 
            </Button>
          </div>
        </Col>
      </Row>
    ),
    altText: "",
    caption: ""
  },
  {
    videoSrc: require("assets/video/p4.mp4"),
    content: (
      <Row>
        <Col className="text-left" md="6">
          <h1 className="title">
            
          </h1>
          <h4 className="description">
          
          </h4>
          <br></br>
          <div className="buttons">
            <Button
              className="btn-neutral mr-1"
              color="info"
              href="#pablo"
              onClick={e => e.preventDefault()}
              size="lg"
            >
              <i className="now-ui-icons files_single-copy-04"></i> 
            </Button>
            <Button
              color="info"
              href="#pablo"
              onClick={e => e.preventDefault()}
              size="lg"
            >
              <i className="now-ui-icons arrows-1_share-66"></i> 
            </Button>
          </div>
        </Col>
      </Row>
    ),
    altText: "",
    caption: ""
  },
  {
    videoSrc: require("assets/video/p5.mp4"),
    content: (
      <Row>
        <Col className="text-left" md="6">
          <h1 className="title">
            
          </h1>
          <h4 className="description">
          
          </h4>
          <br></br>
          <div className="buttons">
            <Button
              className="btn-neutral mr-1"
              color="info"
              href="#pablo"
              onClick={e => e.preventDefault()}
              size="lg"
            >
              <i className="now-ui-icons files_single-copy-04"></i> 
            </Button>
            <Button
              color="info"
              href="#pablo"
              onClick={e => e.preventDefault()}
              size="lg"
            >
              <i className="now-ui-icons arrows-1_share-66"></i> 
            </Button>
          </div>
        </Col>
      </Row>
    ),
    altText: "",
    caption: ""
  },
  {
    videoSrc: require("assets/video/p6.mp4"),
    content: (
      <Row>
        <Col className="text-left" md="6">
          <h1 className="title">
            
          </h1>
          <h4 className="description">
          
          </h4>
          <br></br>
          <div className="buttons">
            <Button
              className="btn-neutral mr-1"
              color="info"
              href="#pablo"
              onClick={e => e.preventDefault()}
              size="lg"
            >
              <i className="now-ui-icons files_single-copy-04"></i> 
            </Button>
            <Button
              color="info"
              href="#pablo"
              onClick={e => e.preventDefault()}
              size="lg"
            >
              <i className="now-ui-icons arrows-1_share-66"></i> 
            </Button>
          </div>
        </Col>
      </Row>
    ),
    altText: "",
    caption: ""
  },
  {
    videoSrc: require("assets/video/p7.mp4"),
    content: (
      <Row>
        <Col className="text-left" md="6">
          <h1 className="title">
            
          </h1>
          <h4 className="description">
          
          </h4>
          <br></br>
          <div className="buttons">
            <Button
              className="btn-neutral mr-1"
              color="info"
              href="#pablo"
              onClick={e => e.preventDefault()}
              size="lg"
            >
              <i className="now-ui-icons files_single-copy-04"></i> 
            </Button>
            <Button
              color="info"
              href="#pablo"
              onClick={e => e.preventDefault()}
              size="lg"
            >
              <i className="now-ui-icons arrows-1_share-66"></i> 
            </Button>
          </div>
        </Col>
      </Row>
    ),
    altText: "",
    caption: ""
  }
];

function Header() {
  // navbar collapses states and functions
  const [navbarOpen1, setNavbarOpen1] = React.useState(false);
  const [navbarOpen2, setNavbarOpen2] = React.useState(false);
  const [navbarOpen3, setNavbarOpen3] = React.useState(false);
  // header 3 carousel states and functions
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [animating, setAnimating] = React.useState(false);
  const onExiting = () => {
    setAnimating(true);
  };
  const onExited = () => {
    setAnimating(false);
  };
  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };
  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };
  const goToIndex = newIndex => {
    if (animating) return;
    setActiveIndex(newIndex);
  };
  return (
    <>
      {navbarOpen1 || navbarOpen2 || navbarOpen3 ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setNavbarOpen1(false);
            setNavbarOpen2(false);
            setNavbarOpen3(false);
          }}
        />
      ) : null}
      
      
      
        <div className="header-3 header-filter">
          
          <Carousel activeIndex={activeIndex} next={next} previous={previous}>
            <CarouselIndicators
              items={items}
              activeIndex={activeIndex}
              onClickHandler={goToIndex}
            />
            {items.map(item => {
              return (
                <CarouselItem
                  onExiting={onExiting}
                  onExited={onExited}
                  key={item.src}
                >
                  <div className="page-header header-filter">
                    <div
                      className="page-header-image"
                     
                    >
<video className="video" autoPlay muted loop style={{ width: '100vw'}}>
      <source src={item.videoSrc}  type="video/mp4" />
    </video>
                    </div>
                    
                  </div>
                </CarouselItem>
              );
            })}
           
          </Carousel>
        </div>
      {/* </div> */}
    </>
  );
}

export default Header;
